import Header from "./components/Header";
import Footer from "./components/Footer";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { ProtectedRoute } from "protected-route-react";
import Home from "./pages/Home";
import PostDetail from "./pages/PostDetail";
import Register from "./pages/Register";
import ErrorPost from "./pages/ErrorPost";
import Login from "./pages/Login";
import UserProfile from "./pages/UserProfile";
import Authors from "./pages/Authors";
import CreatePost from "./pages/CreatePost";
import CategoryPosts from "./pages/CategoryPosts";
import AuthorPosts from "./pages/AuthorPosts";
import Dashboard from "./pages/Dashboard";
import EditPost from "./pages/EditPost";
import DeletePost from "./pages/DeletePost";
import Logout from "./pages/Logout";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useContext } from "react";
import { BASE_URL, UserContext } from "./contexts/UserContext";
import { useEffect } from "react";
import OtherProfile from "./pages/OtherProfile";
import axios from "axios";

function App() {
  const { isAuthenticated,setIsAuthenticated, error,currentUser, setCurrentUser,setError, message, setMessage } = useContext(UserContext);

 useEffect(() => {
  const loadUser = async () => {
    try {
      const { data } = await axios.get(`${BASE_URL}/users/my-profile`, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      

      setCurrentUser(data?.user);
      setMessage(data?.message);
      setError(null);
      setIsAuthenticated(true);
    } catch (error) {
      setError(error?.response?.data?.message);
      setMessage(null);
      setIsAuthenticated(false);
    }
  };

  loadUser();
}, []);   // ✅ empty dependency



  useEffect(() => {
    toast.success(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    setMessage(null);
  }, [message, setMessage]);
  useEffect(() => {
    toast.error(error, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    setError(null)
  }, [error, setError]);



  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/posts/:postId" element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <PostDetail />
          </ProtectedRoute>
        } />
        <Route
          path="/register"
          element={
            <ProtectedRoute
              isAuthenticated={!isAuthenticated}
              redirect={`/profile/${currentUser?._id}`}
            >
              <Register />
            </ProtectedRoute>
          }
        />
        <Route
          path="/login"
          element={
            <ProtectedRoute isAuthenticated={!isAuthenticated} redirect={`/profile/${currentUser?._id}`}>
              <Login />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile/:id"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <UserProfile />
            </ProtectedRoute>
          }
        />
        <Route path="/authors" element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <Authors />
          </ProtectedRoute>
        } />
        <Route
          path="/create"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <CreatePost />
            </ProtectedRoute>
          }
        />
        <Route path="/posts/categories/:category" element={<CategoryPosts />} />
        <Route path="/posts/users/:userId" element={<AuthorPosts />} />
        <Route
          path="/myposts/:postId"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/userprofile/:id" element={<OtherProfile/>}
        />
        <Route
          path="/post/:postId/edit"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <EditPost />
            </ProtectedRoute>
          }
        />
        <Route
          path="/posts/:postid/delete"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <DeletePost />
            </ProtectedRoute>
          }
        />
        <Route path="/logout" element={<Logout />} />
        <Route path="*" element={<ErrorPost />} />
      </Routes>
      <Footer />
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
